//トップページ　キービジュアルスライダー
import 'jquery.cookie';

import {
  no_scroll,
  return_scroll
} from '../common/_common';

export function cameraFunc() {
  let camera = $('#cameraTop').length;
  if (camera) {
    //screen.orientation.lock('portrait');
    let user_id = $.cookie('webcam_user_id');
    let album_id = $.cookie('webcam_album_id');

    let wh = window.innerHeight;

    let frame = document.getElementById("frame");
    let frameWidth = frame.offsetWidth;
    let frameHeight = frame.offsetHeight;

    //縦が短いスマホ用
    let setTimer = false;
    $(window).on('resize', function () {
      if (setTimer !== false) {
        clearTimeout(setTimer);
      }
      setTimer = setTimeout(() => {
        spHeightCheck();
      }, 200);
    });
    function spHeightCheck() {
      wh = window.innerHeight;
      frameHeight = frame.offsetHeight;
      let cameraBtnArea = document.getElementById("frameArea");
      let cameraBtnAreaHeight = cameraBtnArea.offsetHeight;

      if(wh < frameHeight + 10){
        $('.cameraMainArea').addClass('posControl');
        $('#copyRight').addClass('white');
        $('#copyRight img').attr('src', '/images/index/logo.svg');
      } else if(wh < frameHeight + cameraBtnAreaHeight - 50){
        $('.cameraMainArea').addClass('posControl');
        $('.cameraBtnArea').removeClass('black');
        $('#cameraTop').removeClass('bodyColor');
        $('#cameraTop').addClass('bodyImg');
        $('#copyRight').removeClass('white');
        $('#copyRight img').attr('src', '/images/index/logo_black.svg');
      } else{
        $('#cameraTop').addClass('bodyColor');
        $('#cameraTop').removeClass('bodyImg');
        $('.cameraBtnArea').addClass('black');
        $('.cameraMainArea').removeClass('posControl');
        $('#copyRight').removeClass('white');
        $('#copyRight img').attr('src', '/images/index/logo_black.svg');
      }
    }
    spHeightCheck();

    //video要素
    const video = document.getElementById('camera');

    const cameraWidth = window.innerWidth;
    //const cameraHeight = cameraWidth;
    const cameraHeight = cameraWidth * 4 / 3;

    //スマホからの閲覧か
    const isMobile = navigator.userAgent.match(/iPhone|Android/);
    const breakPoint = 750;

    let width = isMobile ? cameraHeight : 480;
    let height = isMobile ? cameraWidth : 640;
    //let height = isMobile ? cameraWidth : 640;

    // let width = cameraWidth;
    // let height = cameraHeight;

    //canvas要素
    const canvas = document.getElementById("canvas");
    const canvas2 = document.getElementById("canvas2");
    const canvas3 = document.getElementById("canvas3");
    const canvas4 = document.getElementById("canvas4");

    //カメラ切り替え
    let facingMode = "environment";
    let cameraFacingIsUser = true; // デフォルトはバックカメラ
    let cameraMode = $('#cameraMode');
    cameraMode.on('click', function () {
      if(cameraFacingIsUser){
        cameraFacingIsUser = false;
        video.classList.add("active");
      }else{
        cameraFacingIsUser = true;
        video.classList.remove("active");
      } 

      cameraInitSmartphoneSupport();
    });

    //カメラ起動
    const cameraInitSmartphoneSupport = () => {
      const video = document.getElementById("camera");

      if(cameraFacingIsUser){
        facingMode = "environment";
      } else{
        facingMode = "user";
      }

      const cameraSetting = {
        audio: false,
        video: {
          aspectRatio: 3 / 4,
          //スマホの場合は縦横を逆に設定する
          width: { ideal: width },
          height: { ideal: height },
          facingMode: facingMode,
        }
      }

      navigator.mediaDevices.getUserMedia(cameraSetting)
      .then((mediaStream) => {
        video.srcObject = mediaStream;
      })
      .catch((err) => {
        console.log(err.toString());
      });
    }
    
    $('#canvas').css({
      opacity: 0,
    });
    cameraInitSmartphoneSupport();
    // document.getElementById("camera").addEventListener('loadedmetadata', () => {
    // //   draw();
    //   stampDraw();
    // });
    $("#exec").prop('disabled', 'true');

    //撮影
    const shoot = () => {
      //video要素
      const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;
      //canvas要素の大きさを変更
      canvas.width = videoWidth;
      canvas.height = videoHeight;
      //描画用オブジェクトを取得
      const ctx = canvas.getContext("2d");

      //描画する
      ctx.drawImage(
        video, // データソース 
        0, // 描画開始x座標  
        0, // 描画開始y座標
        videoWidth, // 描画横サイズ
        videoHeight // 描画縦サイズ
      );
    }

    //カメラ停止
    function stopCamera() {
      const tracks = video.srcObject.getTracks();
      tracks.forEach((track) => {
        track.stop();
      });
      video.srcObject = null;
    }

    //画像をキャンバス上に表示
    function draw(imageObjects) {
      const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;
      const ctx = canvas2.getContext("2d");
      canvas2.width = videoWidth;
      canvas2.height = videoHeight;

      ctx.clearRect(0, 0, videoWidth, videoHeight);
      imageObjects.forEach(obj => {
        ctx.drawImage(obj.img, obj.x, obj.y, obj.width, obj.height);
      });
    }

    //写真とフレームの合成
    function draw2() {
      const ctx = canvas3.getContext("2d");
      canvas3.width = canvas.width;
      canvas3.height = canvas.height;

      if(cameraFacingIsUser){ //バックカメラ
        ctx.drawImage(canvas, 0, 0);
        ctx.drawImage(canvas2, 0, 0);
        ctx.drawImage(canvas4, 0, 0);
      } else{ //フロントカメラ
        ctx.save();
        ctx.translate(canvas3.width, 0);
        ctx.scale(-1, 1);
        ctx.drawImage(canvas, 0, 0);
        ctx.restore();
        ctx.drawImage(canvas2, 0, 0);
        ctx.drawImage(canvas4, 0, 0);
      }
    }

    //ボタンクリックイベント
    function completionBtnFunc(disabled) {
      if(disabled == true){
        $('.completionBtn').addClass('disabled');
        $("#exec").prop('disabled', 'true');
      } else{
        $('.completionBtn').removeClass('disabled');
        $("#exec").prop('disabled', '');
      }
    }
    function completionAlbumBtnFunc(disabled) {
      if(disabled == true){
        $('.completionAlbumBtn').addClass('disabled');
        $("#albumDownload").prop('disabled', 'true');
      } else{
        $('.completionAlbumBtn').removeClass('disabled');
        $("#albumDownload").prop('disabled', '');
      }
    }
    function deleteBtnFunc(disabled) {
      if(disabled == true){
        $('.deleteBtn').addClass('disabled');
        $("#deleteBtn").prop('disabled', 'true');
        $('#modalClose').addClass('disabled');
      } else{
        $('.deleteBtn').removeClass('disabled');
        $("#deleteBtn").prop('disabled', '');
        $('#modalClose').removeClass('disabled');
      }
    }

    //撮影ボタン
    $('#cameraShoot').on('click', function () {
      $('#canvas').css({
        opacity: 1,
      });
      shoot();
      stopCamera();
      $('.confirmArea').addClass('isShow');
      draw2();
    });
    //再度撮影ボタン
    $('#againShooting').on('click', function () {
      $('#canvas').css({
        opacity: 0,
      });
      cameraInitSmartphoneSupport();
      $('.confirmArea').removeClass('isShow');
      $('#picture').removeClass('isShow');
    });
    $('#picture').on('click', '#albumCloseAgainShooting', function () {
      $('#canvas').css({
        opacity: 0,
      });
      cameraInitSmartphoneSupport();
      deleteBtnFunc(true);
      $('.confirmArea').removeClass('isShow');
      $('.modalImgArea').removeClass('isShow');
      $('#picture').removeClass('isShow');
    });
    //一時保存ボタン
    let shutterCount = 0;

    $('#temporarySaving').on('click', function () {
      var capture = document.querySelector('#canvas3');
      const originalStyle = capture.style.width;
      capture.style.width = '600px';
      $('.saveAlertTxt').addClass("isShow");

      html2canvas(capture, {
        useCORS: true,
        scale: 2,
        backgroundColor: null
      }).then(canvas => {
        var base64 = canvas.toDataURL('image/png');

        dbSave(base64, false);

        // 元の表示サイズに戻す
        capture.style.width = originalStyle;

        $('#canvas').css({
          opacity: 0,
        });
        cameraInitSmartphoneSupport();

        setTimeout(() => {
          $('.saveAlertTxt').removeClass("isShow");
        }, 1000); // 自動で閉じる

        $('.confirmArea').removeClass('isShow');
        // shutterCount++;
        // console.log(shutterCount);

        $('#albumSelect').addClass('unread');
        $.cookie('webcam_album_read', false);
      });
    });
    //アルバムボタン
    $('#albumSelect').on('click', function () {
      $('#picture').addClass('isShow');
      $('#albumSelect').removeClass('unread');
      $.cookie('webcam_album_read', true);
      dojQueryAjax();
    });
    if($.cookie('webcam_album_read') == 'false' && user_id){
      $('#albumSelect').addClass('unread');
    }

    //フレームタブ選択
    $('.frameSelectTab .tab').on('click', function () {
      $('.frameSelectTab .tab').removeClass('active');
      $(this).addClass('active');
      let activeTab = $(this).data('tab');

      $('.frameSlideArea').addClass('isHidden');
      $('.frameSlideArea[data-slide="' + activeTab + '"]').removeClass('isHidden');
    });
    //フレーム選択
    $('.frameImg').on('click', function () {
      const imageObjects = [];
      let frameSrc = $(this).children('img').attr('src');

      if($(this).hasClass('resetImg')){
        const videoWidth = video.videoWidth;
        const videoHeight = video.videoHeight;
        const ctx = canvas2.getContext("2d");
        ctx.clearRect(0, 0, videoWidth, videoHeight);
        frameSrc = '';
      }

      $('.frameImg').removeClass('active');
      $(this).addClass('active');
      //$('#frameArea').removeClass('isShow');
      
      // 画像を読み込んでオブジェクトに格納
      const img = new Image();
      img.src = frameSrc;
      const frame = document.getElementById('frame');

      let drawWidth, drawHeight, offsetX, offsetY;
      drawWidth = frame.clientWidth;
      drawHeight = frame.clientWidth / .75;
      offsetX = 0;
      offsetY = (frame.height - drawHeight) / 2;

      img.onload = () => {
        imageObjects.push({
          img: img,
          x: 0,
          y: 0,
          width: drawWidth,
          height: drawHeight
        });

        //console.log(frameSrc);
        draw(imageObjects);
      };
    });
    //フレーム表示
    $('#frameSelect').on('click', function () {
      if($('#frameArea').hasClass('isShow')){
        $('#frameArea').removeClass('isShow');
      } else{
        $('#frameArea').addClass('isShow');
        $('#stampArea').removeClass('isShow');
      }
    });
    //スタンプ・フレーム選択画面を非表示に
    $('#cameraTop').on('touchstart', function (e) {
      if(!$(e.target).closest('.frameSlideArea, .frameSelectTab, #frameSelect, .stampSlideArea, .stampSelectTab, #stampSelect').length) {
        $('#frameArea').removeClass('isShow');
        $('#stampArea').removeClass('isShow');
      } 
    });

    //スタンプ
    let stampObjects = [];
    let draggingImage = null;
    let offsetX, offsetY;
    // ピンチ用
    let pinchIndex = null;
    let initialDistance = 0;
    let initialAngle = 0;
    let initialWidth = 0;
    let initialHeight = 0;
    let initialRatio = 1;

    //スタンプタブ選択
    $('.stampSelectTab .tab').on('click', function () {
      $('.stampSelectTab .tab').removeClass('active');
      $(this).addClass('active');
      let activeTab = $(this).data('tab');

      $('.stampSlideArea').addClass('isHidden');
      $('.stampSlideArea[data-slide="' + activeTab + '"]').removeClass('isHidden');
    });
    $('.stampImg').on('click', function () {
      let stampSrcs = [];
      let stampSrc = $(this).children('img').attr('src');

      stampSrcs.push(stampSrc);

      if($(this).hasClass('resetImg')){
        const videoWidth = video.videoWidth;
        const videoHeight = video.videoHeight;
        const ctx = canvas4.getContext("2d");
        ctx.clearRect(0, 0, videoWidth, videoHeight);
        stampObjects = [];
        stampSrcs = [];
        stampSrc = '';

        if($('.stampDescTxt').hasClass('isShow')){
          $('.stampDescTxt').removeClass('isShow')
        }
      }

      //スタンプ説明テキスト
       if (document.cookie.indexOf('firstStampFlag=true') === -1) {
        $.cookie('firstStampFlag', 'true', { expires: 7 }); // 7日後に期限切れ
        $('.stampDescTxt').addClass('isShow')
      }
      
      // 画像を読み込んでオブジェクトに格納
      stampSrcs.forEach((src, index) => {
        const img = new Image();
        img.src = src;
        img.onload = () => {
          stampObjects.push({
            img: img,
            x: video.videoWidth / 2 - img.width / 2,
            y: video.videoHeight / 2 - img.height / 2,
            width: img.width,
            height: img.height,
            angle: 0,
          });
          stampDraw(stampObjects);

          $('.stampDescTxt').css({
            top: video.videoWidth / 2 - img.width - 15,
          });
        };
      });
    });
    //スタンプ表示
    $('#stampSelect').on('click', function () {
      if($('#stampArea').hasClass('isShow')){
        $('#stampArea').removeClass('isShow');
      } else{
        $('#stampArea').addClass('isShow');
        $('#frameArea').removeClass('isShow');
      }
    });

    //スタンプ描画
    function stampDraw(stampObjects) {
      const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;
      const ctx = canvas4.getContext("2d");
      canvas4.width = videoWidth;
      canvas4.height = videoHeight;

      ctx.clearRect(0, 0, videoWidth, videoHeight);
      stampObjects.forEach(obj => {
        const cx = obj.x + obj.width / 2;
        const cy = obj.y + obj.height / 2;
        ctx.save();
        ctx.translate(cx, cy);
        ctx.rotate(obj.angle);
        ctx.drawImage(obj.img, -obj.width / 2, -obj.height / 2, obj.width, obj.height);

        ctx.restore();
      });
    }

    //スタンプ移動
    function movingStart(e) {
      e.preventDefault();
      // const mouseX = e.offsetX;
      // const mouseY = e.offsetY;

      const touch = e.touches[0];
      const mouseX = touch.clientX;
      const mouseY = touch.clientY;

      // 後ろの画像からチェックするため、逆順
      for (let i = stampObjects.length - 1; i >= 0; i--) {
        const obj = stampObjects[i];
        if (mouseX >= obj.x && mouseX <= obj.x + obj.width && mouseY >= obj.y && mouseY <= obj.y + obj.height ) {
          draggingImage = obj;
          offsetX = mouseX - obj.x;
          offsetY = mouseY - obj.y;

          if (e.touches.length === 2) {
            // 2本指 → ピンチ開始
            const pos1 = getTouchPos(e, 0);
            const pos2 = getTouchPos(e, 1);
    
            initialDistance = getDistance(pos1, pos2);
            initialAngle = getfingerAngle(pos1, pos2);
            initialWidth = stampObjects[i].width;
            initialHeight = stampObjects[i].height;
            initialRatio = stampObjects[i].width / stampObjects[i].height;
          }
          
          // 最前面に移動
          stampObjects.splice(i, 1);
          stampObjects.push(draggingImage);
          break;
        }
      }

      if($('.stampDescTxt').hasClass('isShow')){
        $('.stampDescTxt').removeClass('isShow')
      }
    }

    function inMoving(e) {
      e.preventDefault();
      if (draggingImage) {
        draggingImage.x = e.touches[0].clientX - draggingImage.width / 2;
        draggingImage.y = e.touches[0].clientY - draggingImage.height / 2;

        if (e.touches.length === 2) {
          const pos1 = getTouchPos(e, 0);
          const pos2 = getTouchPos(e, 1);
          const currentDistance = getDistance(pos1, pos2);
          const currentAngle = getfingerAngle(pos1, pos2);

          //スタンプ 回転・拡大・縮小
          if (initialAngle > 0) {
            const angle = (currentAngle - initialAngle) * .05;
            draggingImage.angle = angle;
          }
          if (initialDistance > 0) {
            const scale = currentDistance / initialDistance;
            if (scale > 5) scale = 5;

            if (initialWidth * scale < 90) {
              draggingImage.width = 90;
              draggingImage.height = draggingImage.width * initialRatio;
            } else if (initialWidth * scale > 1000) {
              draggingImage.width = 1000;
              draggingImage.height = draggingImage.width * initialRatio;
            } else{
              draggingImage.width = initialWidth * scale;
              draggingImage.height = initialHeight * scale;
            }
          }
        }

        stampDraw(stampObjects);
      }

      if($('.stampDescTxt').hasClass('isShow')){
        $('.stampDescTxt').removeClass('isShow')
      }
    }

    function movingEnd(params) {
      draggingImage = null;
    }

    //ピンチ時の計算
    function getTouchPos(e, index) {
      const t = e.touches[index];
      const rect = canvas4.getBoundingClientRect();
      return {
        x: t.clientX - rect.left,
        y: t.clientY - rect.top
      };
    }

    function getDistance(a, b) {
      const dx = a.x - b.x;
      const dy = a.y - b.y;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function getfingerAngle(a, b) {
      let angleDegrees = Math.atan2(b.y - a.y, b.x - a.x) * (180 / Math.PI);
      if (angleDegrees < 0) {
        angleDegrees += 360;
      }
      return angleDegrees;
    }

    canvas4.addEventListener("mousedown", e => {
      movingStart(e);
    });
    canvas4.addEventListener("touchstart", e => {
      movingStart(e);
    });

    canvas4.addEventListener("mousemove", e => {
      inMoving(e);
    });
    canvas4.addEventListener("touchmove", e => {
      inMoving(e);
    });

    canvas4.addEventListener("mouseup", () => {
      movingEnd();
    });
    canvas4.addEventListener("touchend", () => {
      movingEnd();
    });
    canvas4.addEventListener("touchcancel", () => {
      movingEnd();
    });

    //HTML画像化イベント登録
    $('#exec').on('click', function () {
      html2image('#canvas3');
      
      $('#canvas').css({
        opacity: 0,
      });
      cameraInitSmartphoneSupport();
      $('.confirmArea').removeClass('isShow');
    });
    //モーダル画像ダウンロード
    $('#picture').on('click', '#albumDownload', function () {
      var capture = document.querySelector('#downloadModalImg');
      let modalImgName = $('#downloadModalImg').children('img').attr('src')
      const newModalImgName = modalImgName.replace('/uploads/', '').replace('.png', '');
      const originalStyle = capture.style.width;
      capture.style.width = '480px';

      html2canvas(capture, {
        useCORS: true,
        scale: 2,
        backgroundColor: null
      })
      .then(canvas => {
        var base64 = canvas.toDataURL('image/png');
        $('#albumImgDownload').attr('href', base64);
        $('#albumImgDownload').attr('download', newModalImgName);
        $('#albumImgDownload')[0].click();				//自動ダウンロード

        // 元の表示サイズに戻す
        capture.style.width = originalStyle;
      })
      .then(res => {
        deleteBtnFunc(true);
        $('.modalImgArea').removeClass('isShow');
      });
    });
    //モーダルを閉じる
    $('#picture').on('click', '#modalClose', function () {
      deleteBtnFunc(true);
      $('#downloadModalImg img').attr('src', '');
      $('.modalImgArea').removeClass('isShow');
    });
    $('#picture').on('click', '#modalImgAreaBack', function () {
      deleteBtnFunc(true);
      $('#downloadModalImg img').attr('src', '');
      $('.modalImgArea').removeClass('isShow');
    });
    //画像選択してモーダル表示
    $('#picture').on('click', '.albumImg', function () {
      deleteBtnFunc();
      let modalSrc = $(this).children('img').attr('src');
      $('#downloadModalImg img').attr('src', modalSrc);
      $('.modalImgArea').addClass('isShow');

      let imgId = $(this).data('id');
      $('#deleteBtn').attr('data-delete_id', imgId);
      let deleteName = modalSrc.replace('/uploads/', '').replace('.png', '');
      $('#deleteBtn').attr('data-delete_name', deleteName);
    });

    //削除機能
    $('#picture').on('click', '#deleteBtn', function () {
      let deleteId = $(this).attr('data-delete_id');
      let deleteName = $(this).attr('data-delete_name');

      console.log(deleteName);

      if(confirm('画像を本当に削除しますか？')){
        
        fetch('../app/config/delete.php', {
          method: 'POST',
          body: JSON.stringify({
            delete_id: deleteId,
            delete_img: deleteName,
            user_id: user_id,
            album_id: album_id
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(res => res.text())
        .then(text => {
          try {
            const data = JSON.parse(data || "null");

            deleteBtnFunc(true);
            $('#downloadModalImg img').attr('src', '');
            $('.modalImgArea').removeClass('isShow');
            dojQueryAjax();

          } catch (e) {
            console.error('JSON parse error:', e, text);
          }
        });

      }else{
        deleteBtnFunc(true);
        $('#downloadModalImg img').attr('src', '');
        $('.modalImgArea').removeClass('isShow');
      }
    });

    let imgName = null;
    function dbSave(base64, dataLoaded) {
      fetch('../app/config/save_user.php', {
        method: 'POST',
        body: JSON.stringify({
          image: base64,
          user_id: user_id,
          album_id: album_id
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.text())
      .then(text => {
        try {
          const data = JSON.parse(data || "null");
          let ret_JSON = JSON.parse(text);
          imgName = ret_JSON["success"];

          if(dataLoaded == true){
            document.dispatchEvent(new CustomEvent('dataLoaded'));
          }
        } catch (e) {
          console.error('JSON parse error:', e, text);
        }
      });
    }

    function html2image(html) {
      var capture = document.querySelector(html);
      const originalStyle = capture.style.width;
      capture.style.width = '480px';

      html2canvas(capture, {
        useCORS: true,
        scale: 2,
        backgroundColor: null
      }).then(canvas => {
        var base64 = canvas.toDataURL('image/png');

        dbSave(base64, true);
        document.addEventListener('dataLoaded', () => {
          const newImgName = imgName.replace('.png', '');
          //console.log(newImgName);
          $('#download').attr('href', base64);
          $('#download').attr('download', newImgName);
          $('#download')[0].click();				//自動ダウンロード

          // 元の表示サイズに戻す
          capture.style.width = originalStyle;
        });
      });
    }

    function dojQueryAjax() {
      $.ajax({
        type: 'POST',
        url: "picture.php",
        cache: false, // キャッシュしないで読み込み
        dataType: "html",
        method: 'post',

        // 通信成功時に呼び出されるコールバック
        success: function (data) {
          $('#picture').html(data);
        },
        // 通信エラー時に呼び出されるコールバック
        error: function (xhr, status, error) {
          console.error('エラーが発生しました:', status, error);
          console.log('レスポンス:', xhr.responseText);
        }
      });
    }
    if (user_id) {
      dojQueryAjax();
    }

  }

  let album = $('#cameraAlbum').length;
  if(album){
    //モーダルを閉じる
    $('#modalClose').on('click', function () {
      $('#modalClose').addClass('disabled');
      $('#downloadModalImg img').attr('src', '');
      $('.modalImgArea').removeClass('isShow');
    });
    $('#modalImgAreaBack').on('click', function () {
      $('#modalClose').addClass('disabled');
      $('#downloadModalImg img').attr('src', '');
      $('.modalImgArea').removeClass('isShow');
    });
    //画像選択してモーダル表示
    $('.albumImg').on('click', function () {
      $('#modalClose').removeClass('disabled');
      let modalSrc = $(this).children('img').attr('src');
      $('#downloadModalImg img').attr('src', modalSrc);
      $('.modalImgArea').addClass('isShow');
    });
  }
}